import {
  POST_TINH_TRANG_NO,
  POST_TINH_TRANG_NO_SUCCESS,
  POST_TINH_TRANG_NO_FAILURE,
} from "actions/DoiTinhTrangNo/actionTypes";

const initialState = {
  postDoiTinhTrangNoLoading: false,
};

const postDoiTinhTrangNo = (state, action) => ({
  ...state,
  postDoiTinhTrangNoLoading: true,
});

const postDoiTinhTrangNoSuccess = (state, action) => {
  return {
    ...state,
    postDoiTinhTrangNoLoading: false,
  };
};

const postDoiTinhTrangNoFailed = (state, action) => ({
  ...state,
  postDoiTinhTrangNoLoading: false,
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_TINH_TRANG_NO:
      return postDoiTinhTrangNo(state, action);
    case POST_TINH_TRANG_NO_SUCCESS:
      return postDoiTinhTrangNoSuccess(state, action);
    case POST_TINH_TRANG_NO_FAILURE:
      return postDoiTinhTrangNoFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
